import React, { memo } from 'react';

import { useSelector } from 'react-redux';

import dynamic from 'next/dynamic';

import _get from 'lodash/get';
import _isEqual from 'lodash/isEqual';

import { useDevice } from '@bonnet/next/device';

import { useFeatures } from '@atc/features';

import { Col, Row } from 'reaxl';

import userPreferencesDuck from '@/ducks/userPreferencesDuck.js';

// containers

import CompareDrawerPlaceholder from '@/components/CompareDrawerPlaceholder';
import LazyComponent from '@/components/LazyComponent';
import MobileSearchFilterButtons from '@/components/SearchLink/MobileSearchFilterButtons';

import FilterMobileControlsContainer from './FilterMobileControlsContainer';
import InventoryClearFilters from './InventoryClearFilters';
import SaveSearchContainer from './SaveSearchContainer';
import SuggestedFilterContainer from './SuggestedFilterContainer';

const CompareListingsDrawer = dynamic(() => import(
    /* webpackChunkName: "CompareListingsDrawer" */
    '@/components/CompareListingsDrawer'
), {
    loading: () => (
        <CompareDrawerPlaceholder />
    ),
    ssr: false,
});

function SearchResultsPageTopActionsContainer() {
    const {
        compare: [enableCompare],
        srp_redesigned_sticky_header: [redesignedStickyHeader],
        suggested_filters: [enableSuggestedFilters],
    } = useFeatures([
        'compare',
        'my_wallet',
        'remove_payments_toggle',
        'srp_redesigned_sticky_header',
        'suggested_filters',
    ]);

    const device = useDevice();
    const isXs = _get(device, 'is.xs', false);
    const isLg = _get(device, 'is.lg', false);

    const showDrawer = useSelector(userPreferencesDuck.selectors.getShowDrawer);

    if (!isXs) {
        return (
            <>
                {showDrawer && enableCompare && (
                    <LazyComponent
                        fallback={<CompareDrawerPlaceholder />}
                        key="compare-drawer-top-placeholder"
                    >
                        <CompareListingsDrawer
                            isCollapsible
                            parent="top"
                        />
                    </LazyComponent>
                )}
                {enableSuggestedFilters && (
                    <Row>
                        <Col
                            xs={12}
                            className="display-flex justify-items-center align-items-center"
                        >
                            {!isLg && (
                                <MobileSearchFilterButtons />
                            )}
                            <div
                                className="display-flex align-items-center flex-nowrap"
                                style={{ minWidth: '1px' }}
                            >
                                <SaveSearchContainer
                                    key="saveSearchContainer"
                                />
                                <InventoryClearFilters
                                    key="clearFilters"
                                    className="margin-right-3"
                                />
                                <div
                                    className="padding-top-sm-0"
                                    style={{ minWidth: '100px' }}
                                >
                                    <SuggestedFilterContainer />
                                </div>
                            </div>
                        </Col>
                    </Row>
                )}
            </>
        );
    }

    return (
        <Row
            data-cmp="cntnr-pg-num-top"
        >
            {!redesignedStickyHeader && <FilterMobileControlsContainer />}
        </Row>
    );
}

export default memo(SearchResultsPageTopActionsContainer, _isEqual);
